<template>
    <div class="project-details-page-container-fluid" style="width: 90vw; max-width: 1600px; margin: auto;">
        <!-- <NavBar/> -->
        <div style="font-weight: 520; font-size: 2rem; margin-top: 2vw; width: 100%; max-width: 1600px">{{ project.name }}
            <hr>
        </div>
        <div style="font-weight: 520; font-size: 1.2rem; width: 100%;">{{ project.location }}</div>
        <div class="project-details-container">
            <div class="project-header">
                <div class="project-details">
                    <p style="font-weight: 520; font-size: 1.2rem;">{{ project.date }}</p>
                    <hr>
                    <p style="font-weight: 520; font-size: 1.2rem; margin-bottom: 0px;" v-if="project.partners">Project Partners</p>
                    <p style="font-weight: 520; font-size: 1.2rem; color:#7b7b7b" v-if="project.partners">{{ project.partners }}</p>
                    <!-- <p style="font-weight: 520; font-size: 1.2rem;" v-else>Prime Consultants</p> -->
                    <hr  v-if="project.partners">
                    <p style="font-weight: 520; font-size: 1.2rem;">Project Owner</p>
                    <p style="font-weight: 520; font-size: 1.2rem;color:#7b7b7b">{{ project.agency }}</p>
                    <hr>    
                    <p style="font-weight: 520; font-size: 1rem; line-height: 1.4rem; color:#7b7b7b; white-space: pre-wrap;">{{ project.description }}</p>
                </div>
            </div>
            <div class="project-body">
                <div class="project-images">
                    <img v-for="i in project.images" :key="i" :src="`${imageBase}/${project.id}_${i - 1}.jpg`"
                        alt="Project Image">
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import api, { imageBase } from '@/api/config';
import { useHead } from '@vueuse/head';
import { ref, computed } from 'vue';
// import NavBar from '../../../navbar/NavBar.vue'
export default {
    components: {
        // NavBar
    },
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
    },
    setup() {
        const projectName = ref('Project');
        const projectDescription = ref('');
        const projectId = ref('');

        useHead({
            title: computed(() => `${projectName.value} | MP Engineers + Architects`),
            meta: [
                { name: 'description', content: computed(() => projectDescription.value || 'View project details from MP Engineers + Architects — a multi-disciplinary consulting firm specializing in infrastructure, facilities, and construction management.') },
                { property: 'og:title', content: computed(() => `${projectName.value} | MP Engineers + Architects`) },
                { property: 'og:description', content: computed(() => projectDescription.value || 'View project details from MP Engineers + Architects.') },
                { property: 'og:url', content: computed(() => `https://www.mpengs.com/project/${projectId.value}`) },
                { name: 'twitter:title', content: computed(() => `${projectName.value} | MP Engineers + Architects`) },
            ],
            link: [{ rel: 'canonical', content: computed(() => `https://www.mpengs.com/project/${projectId.value}`) }],
        });

        return { projectName, projectDescription, projectId };
    },
    data() {
        return {
            imageBase,
            project: {
                name: "Name",
                location: "None",
            },
        };
    },
    mounted() {
        this.fetchProjectDetails();
    },
    methods: {
        async fetchProjectDetails() {
            try {
                const response = await api.get(`/project/${this.id}`);
                this.project = response.data;
                this.projectName = response.data.name;
                this.projectDescription = response.data.description;
                this.projectId = response.data.id;
            } catch (error) {
                console.error('Failed to fetch project details:', error);
            }
        },
    },
};
</script>

<style>
html, body {
    width: 100%;
    height: 100%;
    overflow-x: hidden; /* Prevents horizontal scroll */
    overflow-y: auto; /* Allows vertical scroll */
}
html::-webkit-scrollbar {
    display: none;
}
hr {
    border: none; 
    height: 1px;
    background-color: black;
    margin: 10px 0;
}

.project-details-page-container-fluid{
    width: 90vw;
    max-width: 1600px;
    margin: auto;
}

.project-details-page-container-fluid::-webkit-scrollbar{
    display: none;
}
.project-details-container {
    display: flex;
    width: 100%;
    max-width: 1600px;
}
.project-header{
    width: 100%;
    display: block;
}
.project-body {
    width: 95%;
    display: block;
    margin-left: 5%;
}

.project-details {
    width: 100%;
    text-align: justify;
    hyphens: auto;
}

.project-images {
    width: calc(100% - 10px);
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 5vw;
}

.project-images img {
    width: 100%;
    margin-bottom: 10px;
}

@media (max-width: 768px) {
    .project-details-page-container-fluid{
        width:calc(100vw - 40px);
    }
    .project-details-container{
        display: block;
    }
    .project-details,
    .project-description,
    .project-images {
        width: 100%;
    }
    .project-images{
        margin: 0px;
        padding: 0px;
        width: 90vw;
    }
    .project-images img {
        width: 100%;
    }
    .project-body {
        width: 100%;
        display: block;
        margin-left: 0px;
    }
    
}
</style>